import React from "react";
import { Skeleton as PRSkeleton, SkeletonProps } from "primereact/skeleton";

export default function Skeleton(props: SkeletonProps) {
   return <PRSkeleton {...props} />;
}
